import React, { useMemo, useRef } from 'react'
import { useReduxSelector } from '../redux/hooks';
import ChatDialog from './ChatDialog';
import { ChatApi } from '../redux/api/ChatApi';
import { IChat } from '../types/IChat';

export default function PinnedChats() {
    const { data: pins } = ChatApi.useGetPinnedChatsQuery();
    const { data: config } = ChatApi.useGetConfigQuery();

    let pinnedChats = useMemo(() =>
        //chats?.concat(requests)?.filter(c => pins?.find(p => p?.Contact_Id === profile?.Id && p?.Chat_Id === c.Id))
        pins?.filter(p => p).map(p => p.ConversationId)
        , [pins])

    function chatUnpinned(chat: IChat) {
        // 
        // pinnedChats = pinnedChats.filter(p => p.ConversationId == chat.ConversationId)
        // console.log('chatUnpinned 2', chat, pinnedChats)
    }

    const parent = useRef();

    let totalLeft = 20;

    return (
        <div className='pinned-chats' ref={parent}>
            {pinnedChats?.slice(0, config?.Max_Chats ?? 3).map((p, i) => {
                const prev = i > 0 ? pinnedChats[i - 1] : null;
                //const leftPx = prev && (!prev?.Staff_Expanded ? 250 : 400) + (20);
                const leftPx = prev && 400 + (20);
                totalLeft += leftPx;
                return <ChatDialog anchor={parent.current} leftPx={totalLeft} unPinned={chatUnpinned} key={`${p.toString()}_${i}`} id={p.toString()} index={i} />
            })}
        </div>
    )
}
